<template>
  <el-row :gutter="15">
    <el-col :span="24" :lg="6">
      <el-card class="wiki-part">
        <div class="clearfix mb-10">
          <div class="pull-right" style="width: 40px">
            <el-button
              class="d-iblock ma-0"
              type="primary"
              size="small"
              title="新建顶层文件分类"
              style="margin-left: 0"
              @click="onAddFileClassify"
            >
              <i class="fas fa-fw fa-plus" aria-hidden="true" />
            </el-button>
          </div>
          <div style="margin-right: 45px">
            <el-input
              v-model="filterText"
              placeholder="请输入关键字"
              style="width: 100%"
            ></el-input>
          </div>
        </div>

        <el-tree
          ref="fileClassifyTree"
          :data="fileClassifyList"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :highlight-current="true"
          :expand-on-click-node="false"
          :default-expanded-keys="expandedKeys"
          :current-node-key="currentKey"
          :render-content="onRenderContent"
          class="filter-tree"
          node-key="ID"
          @node-click="clickNode"
        ></el-tree>
      </el-card>
    </el-col>

    <el-col :span="24" :lg="18">
      <el-card>
        <div class="clearfix mb-10">
          <div class="pull-left">
            <!-- <el-button type="primary" @click="onCreateItem()">
              <i class="fas fa-plus"></i> 上传文件
            </el-button> -->
            <el-upload
              ref="upload"
              action=""
              :headers="uploadHeader"
              :multiple="false"
              :limit="1"
              :show-file-list="false"
              :http-request="
                (file) => {
                  return imggreySuccess(file);
                }
              "
              style="display: inline-block"
            >
              <el-button
                size="small"
                type="primary"
                :disabled="this.former.FileClassifyID === ''"
                >选择文件</el-button
              >
            </el-upload>
            &nbsp;
            <span style="font-size: small; color: #409eff">{{
              indexName
            }}</span>
          </div>
        </div>
        <el-table :data="itemList" v-loading="loading" tooltip-effect="light">
          <el-table-column
            type="index"
            :index="pager.size * (pager.page - 1) + 1"
            :width="
              Math.max(48, (pager.size * pager.page).toString().length * 12)
            "
          />
          <el-table-column prop="Name" label="文件名">
            <template slot-scope="scope">
              {{ scope.row.Name }}
              <el-tooltip
                content="Top center"
                placement="top"
                effect="light"
                v-if="scope.row.DownloadUrl !== ''"
              >
                <div slot="content">
                  下载地址:<br />{{ scope.row.DownloadUrl }}
                </div>
                <i
                  class="fas fa-clone"
                  style="color: #67c23a; cursor: pointer"
                  v-clipboard="scope.row.DownloadUrl"
                  v-clipboard:success="onSuccess"
                  v-clipboard:error="onError"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="Type" label="文件类型" width="80">
            <template slot-scope="scope">
              <span>{{ typeList[scope.row.Type] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Md5"
            label="MD5"
            width="50"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                content="Top center"
                placement="top"
                effect="light"
                v-if="scope.row.Md5 !== ''"
              >
                <div slot="content">{{ scope.row.Md5 }}</div>
                <el-button
                  type="warning"
                  circle
                  size="mini"
                  v-clipboard="scope.row.Md5"
                  v-clipboard:success="onSuccess"
                  v-clipboard:error="onError"
                >
                  <i class="fas fas fa-th"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="Remark"
            label="说明"
            show-overflow-tooltip
            width="100"
          />
          <el-table-column prop="Person" label="上传者" width="80" />
          <el-table-column prop="CreatedAt" label="上传时间" width="140">
            <template slot-scope="scope">
              {{
                scope.row.CreatedAt &&
                $sys.dateFormat(new Date(scope.row.CreatedAt))
              }}
            </template>
          </el-table-column>
          <el-table-column width="150" label="操作">
            <template slot-scope="scope">
              <el-button
                type="success"
                @click.stop="onDownload(scope.row)"
                title="下载"
                :disabled="scope.row.DownloadUrl === ''"
              >
                <i class="fas fa-download"></i>
              </el-button>
              <el-button
                type="primary"
                @click.stop="onShowItem(scope.row)"
                title="详情"
              >
                <i class="fas fa-fw fa-edit"></i>
              </el-button>
              <el-button
                type="danger"
                @click.stop="onDeleteItem(scope.row)"
                title="删除"
                :disabled="!scope.row.CanDel"
              >
                <i class="fas fa-trash-alt"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pull-right clearfix mar-top-10">
          <el-pagination
            @current-change="onChangePage"
            layout="total, prev, pager, next"
            :total="pager.total"
            :current-page="pager.page"
            :page-size="pager.size"
          ></el-pagination>
        </div>
      </el-card>
    </el-col>

    <el-dialog
      :title="(fileClassifyData.ID ? '编辑' : '新建') + '文件分类'"
      :visible.sync="fileClassifyEditing"
      :close-on-click-modal="false"
      width="600px"
      top="5vh"
      @open="onOpen"
      @close="onClose"
    >
      <el-form
        ref="fileClassifyDataForm"
        :model="fileClassifyData"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="上级分类名称" prop="ParentID">
          <!--当前点击的就是默认新建了上级名称-->
          <el-select
            v-model="fileClassifyData.ParentID"
            :clearable="false"
            placeholder="请选择上级"
            style="width: 100%"
          >
            <el-option
              v-for="(c, index) in fileClassifySelectList"
              :key="index"
              :label="c.ClassifyName"
              :value="c.ID"
              :style="{ marginLeft: 15 * c.space + 'px' }"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件分类名称" prop="ClassifyName">
          <el-input
            v-model.trim="fileClassifyData.ClassifyName"
            placeholder="请输入分类名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="text-muted">注：上级名称为0则视为根目录。</div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="fileClassifyData.ID"
          class="pull-left"
          type="danger"
          @click="removeFileClassify(fileClassifyData)"
        >
          <i class="fas fa-fw fa-trash"></i> 删 除
        </el-button>
        <el-button @click="fileClassifyEditing = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          :disabled="classifySubmitDisable || !fileClassifyData.ClassifyName"
          type="primary"
          @click="operateClassify"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <item-form
      v-model="item"
      :group="group"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
  </el-row>
</template>

<script>
import ItemForm from "./index--form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      group: 0, //业务组类型 0.嵌入式 1.工控
      //===================左边树===================
      isParent: false, // 是不是父级的分类
      fileClassifyEditing: false,
      fileClassifyData: this.getEmptyFileClassify(), //文件分类信息
      filterText: "", //检索文件分类
      fileClassifyList: [], //树的数据源，只有根节点，子节点在根节点children中
      defaultProps: {
        label: "ClassifyName",
        children: "Children",
      },
      expandedKeys: [], //id
      currentKey: "",
      indexName: "",
      fileClassifyActiveData: {}, //当前选中的节点信息
      lastKeyHighlight: "", // 最终要高亮的值，以前高亮之后再拉数据没有关系，现在不行了，只能先拉数据再高亮
      classifySubmitDisable: false,
      fileClassifySelectList: [], //文件分类选择列表，所有节点列表
      spanceNum: 0,
      rules: {
        ClassifyName: [
          {
            required: true,
            message: "文件分类名称不能为空",
            trigger: "change, blur",
          },
          {
            max: 200,
            message: "文件分类名称不能超过200个字符",
            trigger: "change, blur",
          },
        ],
      },
      treePager: {
        total: 0,
        page: 1,
        size: -1,
      },

      //===================右边列表===================
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        FileClassifyID: "", //所属文件分类
      },
      item: {},
      itemVisible: false,
      typeList: {
        1: "文档", // 除了下面两种情况暂时都认为是文档
        2: "图片", // .jpg, .jpeg, .png, .gif
        3: "压缩包", // .zip, .rar
      },
      url: "",
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
    };
  },
  created() {
    this.group = this.$route.meta.group;
    this.getFileClassifyTree();
  },
  watch: {
    filterText(val) {
      this.fileClassifyActiveData = {};
      this.expandedKeys = [];
      this.indexName = "";
      this.former.FileClassifyID = "";
      this.itemList = [];
      this.$refs.fileClassifyTree.filter(val);
    },
  },
  methods: {
    //===================左边树===================
    //获取文件分类树
    getFileClassifyTree() {
      this.fileClassifyList = [];
      this.fileClassifySelectList = [];
      this.$axios
        .get(this.group === 0 ? "dci/fileclassify" : "ipc/fileclassify", {
          params: {
            where: {
              BusinessGroup: this.group,
            },
            return_tree: 1,
            ...this.treePager,
          },
        })
        .then((response) => {
          response.data.forEach((ele) => {
            this.spanceNum = 0;
            this.getChild(ele);
          });
          this.fileClassifyList = response.data; //树数据源

          if (!this.fileClassifyActiveData.ID) {
            this.fileClassifyActiveData = response.data[0];
            this.indexName =
              response.data[0].IndexName === ""
                ? ""
                : "<<" + response.data[0].IndexName;
            this.former.FileClassifyID = this.fileClassifyActiveData.ID;
            this.onSubmitQuery();
            this.expandedKeys = [response.data[0].ID];
            this.lastKeyHighlight = response.data[0].ID;
          }
          this.setCurrentKeySelf(this.lastKeyHighlight);
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 递归获取,因为不知道children有多少层
    getChild(item) {
      const data = item;
      this.spanceNum = 0;
      this.getSpanceNum(data);
      data.space = this.spanceNum;
      if (!data.Children) {
        data.Children = [];
      }
      this.fileClassifySelectList.push(data);
      data.Children.forEach((childItem) => {
        this.getChild(childItem);
      });
    },
    // 计算这个之前有多少个父结点，就要显示多少个空格
    getSpanceNum(item) {
      if (item.ParentID !== 0) {
        this.spanceNum++;
        this.getSpanceNum(
          this.fileClassifySelectList[
            _.findIndex(
              this.fileClassifySelectList,
              (c) => c.ID === item.ParentID
            )
          ]
        );
      }
    },
    // //获取文件分类列表
    // getFileClassifyList() {
    //   const params = {
    //     return_list: 1,
    //   };
    //   this.$axios
    //     .get(this.group === 0 ? "dci/fileclassify" : "ipc/fileclassify", {
    //       params,
    //     })
    //     .then((response) => {
    //       this.fileClassifyList = response.data.data;
    //     })
    //     .catch(({ response }) => {
    //       this.$sys.alarmResponse(response);
    //     })
    //     .finally(() => {});
    // },
    //新建顶层文件分类
    onAddFileClassify() {
      this.isParent = true;
      this.fileClassifyData = this.getEmptyFileClassify();
      this.fileClassifyEditing = true;
    },
    //清空文件分类信息
    getEmptyFileClassify() {
      return {
        ClassifyName: "",
        ParentID: 0,
        BusinessGroup: this.group,
      };
    },
    // 对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示
    filterNode(value, data) {
      return data.ClassifyName.includes(value);
    },
    //点击树节点
    clickNode(data) {
      this.fileClassifyActiveData = data;
      this.expandedKeys = [data.ID];
      this.indexName = data.IndexName === "" ? "" : "<<" + data.IndexName;
      this.former.FileClassifyID = data.ID;

      this.onSubmitQuery();
    },
    onOpen() {
      // if (this.fileClassifyList.length === 0) {
      //   this.getFileClassifyList();
      // }
    },
    onClose() {
      this.fileClassifyEditing = false;
      this.classifySubmitDisable = false;
      this.$refs.fileClassifyDataForm.resetFields();
      this.fileClassifyData = this.getEmptyFileClassify();
    },
    // 在节点中添加自定义内容，即添加，编辑，删除,功能按钮
    onRenderContent(h, { node, data }) {
      if (data.ID === 0) {
        //根节点
        return (
          <div class="show-node">
            <span>
              <span title={data.ClassifyName}>{data.ClassifyName}</span>
            </span>
          </div>
        );
      }
      return (
        <div class="show-node">
          <span>
            <span title={data.ClassifyName}>{data.ClassifyName}</span>
          </span>
          <span class="adjust-btn">
            {
              <el-button
                class="pr-10"
                type="text"
                title="添加"
                onClick={(event) => this.onTypeCreate(event, data)}
              >
                <i class="fas fa-fw fa-plus"></i>
              </el-button>
            }
            {
              <el-button
                type="text"
                title="编辑"
                onClick={(event) => this.onTypeEdit(node, event, data)}
              >
                <i class="fas fa-fw fa-edit"></i>
              </el-button>
            }
          </span>
        </div>
      );
    },
    // 添加父/子级分类
    onTypeCreate(event, data) {
      if (event) {
        // 阻止事件冒泡
        event.stopPropagation();
      }
      // 如果有值，表示添加的不是父级的分类
      if (data) {
        this.isParent = false;
        this.fileClassifyData.ParentID = data.ID;
        this.fileClassifyActiveData = data;
      } else {
        this.isParent = true;
      }
      this.fileClassifyData.BusinessGroup = this.group;
      this.lastKeyHighlight = data.ID;
      this.fileClassifyEditing = true;
    },
    // 编辑分类
    onTypeEdit(node, event, data) {
      if (event) {
        // 阻止事件冒泡
        event.stopPropagation();
      }
      // 当前节点点击数据
      this.fileClassifyData = { ...data };
      // 如果不是Null，表示添加的不是父级的分类
      if (data.ParentID !== 0) {
        this.isParent = false;
      } else {
        this.isParent = true;
      }
      this.fileClassifyActiveData = data;
      this.fileClassifyEditing = true;
    },
    // 删除分类
    removeFileClassify(data) {
      this.$confirm("是否删除该文件分类？", "请确定", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() =>
          this.$axios.delete(
            this.group === 0
              ? `dci/fileclassify/${data.ID}`
              : `ipc/fileclassify/${data.ID}`
          )
        )
        .then(() => {
          this.fileClassifyEditing = false;
          if (this.former.FileClassifyID === data.ID) {
            this.fileClassifyActiveData = {};
            this.expandedKeys = [];
            this.former.FileClassifyID = "";
            this.indexName = "";
            this.itemList = [];
          }
          this.filterText = "";
          this.getFileClassifyTree();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 分类的新增和编辑操作
    operateClassify() {
      this.$refs.fileClassifyDataForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.classifySubmitDisable = true;
        this.$axios
          .request({
            url: this.fileClassifyData.ID
              ? this.group === 0
                ? `dci/fileclassify/${this.fileClassifyData.ID}`
                : `ipc/fileclassify/${this.fileClassifyData.ID}`
              : this.group === 0
              ? "dci/fileclassify"
              : "ipc/fileclassify",
            method: this.fileClassifyData.ID ? "put" : "post",
            data: this.fileClassifyData,
          })
          .then(() => {
            this.$message.success(
              this.fileClassifyData.ID ? "成功更新文件分类" : "成功新增文件分类"
            );
            // this.getFileClassifyList();
            this.filterText = "";
            this.getFileClassifyTree();
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          })
          .finally(() => {
            this.fileClassifyEditing = false;
            this.classifySubmitDisable = false;
          });
      });
    },
    // 手动设置currentKey
    setCurrentKeySelf(data) {
      this.$nextTick(() => {
        this.$refs.fileClassifyTree.setCurrentKey(data);
      });
    },

    //===================右边列表===================
    getItemList() {
      this.loading = true;
      this.$axios
        .get(this.group === 0 ? "dci/file" : "ipc/file", {
          params: {
            where: this.former,
            ...this.pager,
            with: ["FileClassify"],
            order: ["-created_at"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      if (this.former.FileClassifyID !== "") {
        // this.fileClassifyActiveData = this.former.FileClassifyID;
        this.expandedKeys = [this.former.FileClassifyID];

        // 应该把它的父级节点都找到打开
        this.getParent(
          this.fileClassifySelectList[
            _.findIndex(
              this.fileClassifySelectList,
              (c) => c.ID === this.former.FileClassifyID
            )
          ]
        );

        this.lastKeyHighlight = this.former.FileClassifyID;
        this.setCurrentKeySelf(this.lastKeyHighlight);
      } else if (this.former.FileClassifyID === "") {
        this.fileClassifyActiveData = {};
        this.lastKeyHighlight = null;
        this.setCurrentKeySelf(this.lastKeyHighlight);
      }
      this.pager.page = 1;
      this.getItemList();
    },
    getParent(data) {
      // 追加父级节点id
      this.expandedKeys.push(data.ID);
      if (data.ParentID !== 0) {
        this.getParent(
          this.fileClassifySelectList[
            _.findIndex(
              this.fileClassifySelectList,
              (c) => c.ID === data.ParentID
            )
          ]
        );
      }
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },

    onShowItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    //上传附件
    async imggreySuccess(params) {
      this.loading = true;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", params.file);
      formData.append("fileclassifyid", this.fileClassifyActiveData.ID);
      this.$axios
        .post(
          this.group === 0 ? "dci/file/upload" : "ipc/file/upload",
          formData
        )
        .then(() => {
          this.$message.success("上传成功");
          this.getItemList();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.$refs["upload"].clearFiles();
          this.loading = false;
        });
    },

    onDeleteItem(row) {
      this.$confirm("确定要删除此文件吗？", "提示")
        .then(() =>
          this.$axios.delete(
            this.group === 0 ? `dci/file/${row.ID}` : `ipc/file/${row.ID}`
          )
        )
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除文件");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    //下载
    async onDownload(row) {
      this.loading = true;
      const { data } = await this.$axios({
        url: row.DownloadUrl,
        responseType: "blob",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      });
      const blob = new Blob([data], {
        type: "application/*;chartset=UTF-8",
      });
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = row.Name;
      a.click();
      window.URL.revokeObjectURL(url);
      this.loading = false;
    },
    onSuccess() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.success("复制失败");
    },
  },
};
</script>

<style lang="scss">
.wiki-part {
  .el-tree-node__content {
    position: relative;
  }
  .show-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    font-size: 14px;
    padding-top: 5px;
  }
  .adjust-btn {
    display: none;
    position: absolute;
    right: 15px;
  }
  .show-node:hover .adjust-btn {
    display: block;
  }
  .adjust-btn .el-button {
    margin: 0;
  }
}
.d-iblock {
  display: inline-block;
}
.standard-search {
  margin-right: 0.5em;
  .el-select {
    .el-input .el-input__inner {
      height: 28px !important;
    }
    .el-select__tags,
    .el-select__tags span {
      white-space: nowrap;
      overflow: hidden;
      flex-wrap: nowrap;
    }
  }
  vertical-align: middle;
}
</style>
